import { AppAreaConfig } from '@/funnels/@types'

import medGlp1 from './areas/med.simple.life/glp-1'

// fasting
import fastingFemale from './areas/fasting/female'
import fastingMale from './areas/fasting/male'
import fastingMain from './areas/fasting/main'
import fastingFemaleWaterBalance from './areas/fasting/female-water-balance'
import fastingFemaleWaterFasting from './areas/fasting/female-water-fasting'
import fastingMaleWaterFasting from './areas/fasting/male-water-fasting'
import fastingFemaleAyurvedaFwf from './areas/fasting/female-ayurveda-fwf'
import fastingFemalePr from './areas/fasting/female-pr'
import fastingMalePr from './areas/fasting/male-pr'
import fastingMainPr from './areas/fasting/main-pr'

// yoga
import yogaActivityFemaleYoga from './areas/yoga/activity-female-yoga'
import yogaActivityMaleChairWorkouts from './areas/yoga/activity-male-chair-workouts'
import yogaMainYoga from './areas/yoga/main-yoga'

// walking
import walkingActivityFemaleWalking from './areas/walking/activity-female-walking'
import walkingActivityMaleWalking from './areas/walking/activity-male-walking'
import walkingFemalePrintableWalking from './areas/walking/female-printable-walking'
import walkingActivityFemaleWalkingJapanese from './areas/walking/activity-female-walking-japanese'
import walkingActivityFemaleWalkingJapaneseV2 from './areas/walking/activity-female-walking-japanese-v2'
import walkingActivityFemaleNordicWalkingFwf from './areas/walking/activity-female-nordic-walking-fwf'
import walkingMainWalking from './areas/walking/main-walking'

// pilates
import pilatesActivityFemalePilates from './areas/pilates/activity-female-pilates'
import pilatesActivityFemaleSeniorPilates from './areas/pilates/activity-female-senior-pilates'
import pilatesActivityFemaleBoudoirPilatesFwf from './areas/pilates/activity-female-boudoir-pilates-fwf'
import pilatesActivityFemaleAsianPilates from './areas/pilates/activity-female-asian-pilates'

// activity
import activityActivityFemaleV2 from './areas/activity/activity-female-v2'
import activityActivityMale from './areas/activity/activity-male'
import activityMainActivity from './areas/activity/main-activity'

// tai-chi
import taiChiActivityFemaleTaiChi from './areas/tai-chi/activity-female-tai-chi'
import taiChiActivityFemaleTaiChiWalking from './areas/tai-chi/activity-female-tai-chi-walking'
import taiChiActivityFemaleTaiChiWalkingV2 from './areas/tai-chi/activity-female-tai-chi-walking-v2'
import taiChiActivityFemaleTaiChiWalkingPr from './areas/tai-chi/activity-female-tai-chi-walking-pr'
import taiChiActivityFemaleChairTaiChiFwf from './areas/tai-chi/activity-female-chair-tai-chi-fwf'
import taiChiActivityMaleTaiChiWalking from './areas/tai-chi/activity-male-tai-chi-walking'
import taiChiActivityMaleTaiChiYoga from './areas/tai-chi/activity-male-tai-chi-yoga'
import taiChiActivityMaleTaiChiYogaPr from './areas/tai-chi/activity-male-tai-chi-yoga-pr'
import taiChiMainTaiChi from './areas/tai-chi/main-tai-chi'
import taiChiMainTaiChiPr from './areas/tai-chi/main-tai-chi-pr'
import taiChiMainTaiChiWalking from './areas/tai-chi/main-tai-chi-walking'
import taiChiMainTaiChiWalkingPr from './areas/tai-chi/main-tai-chi-walking-pr'
import taiChiActivityMaleChairTaiChi from './areas/tai-chi/activity-male-chair-tai-chi'
import taiChiMaleGolfersFwf from './areas/tai-chi/tai-chi-male-golfers-fwf'
import taiChiMainChairTaiChiPr from './areas/tai-chi/main-chair-tai-chi-pr'

// glp
import glpFemaleGlp from './areas/glp/female-glp'

// calisthenics
import calisthenicsActivityFemaleCalisthenics from './areas/calisthenics/activity-female-calisthenics'
import calisthenicsActivityMaleCalisthenics from './areas/calisthenics/activity-male-calisthenics'
import calisthenicsMainCalisthenics from './areas/calisthenics/main-calisthenics'
import calisthenicsMilitaryMale from './areas/calisthenics/military-male'

// diets
import dietsFemaleCortisolDiet from './areas/diets/female-cortisol-diet'
import dietsFemaleMenopauseDiet from './areas/diets/female-menopause-diet'
import dietsFemaleMediterraneanDiet from './areas/diets/female-mediterranean-diet'
import dietsFemaleAntiInflammatoryDiet from './areas/diets/female-anti-inflammatory-diet'
import dietsFemaleHashimotoDiet from './areas/diets/female-hashimoto-diet'
import dietsFemaleHighProtein from './areas/diets/female-high-protein'
import dietsFemaleRamadanFwf from './areas/diets/female-ramadan-fwf'
import dietsCarnivoreDietGs from './areas/diets/carnivore-diet-gs'
import dietsCarnivoreDietGsMale from './areas/diets/carnivore-diet-gs-male'
import dietsCarnivoreDietGsFemale from './areas/diets/carnivore-diet-gs-female'
import dietsJapaneseDiet from './areas/diets/japanese-diet'
import dietsJapaneseDietMale from './areas/diets/japanese-diet-male'
import dietsJapaneseDietFemale from './areas/diets/japanese-diet-female'
import dietsFemaleKoreanGlowDiet from './areas/diets/female-korean-glow-diet'

// applovin
import applovinMainTaiChiWalkingAl from './areas/applovin/main-tai-chi-walking-al'
import applovinActivityFemalePilatesAl from './areas/applovin/activity-female-pilates-al'
import applovinActivityFemaleWalkingAl from './areas/applovin/activity-female-walking-al'
import applovinActivityFemaleYogaAl from './areas/applovin/activity-female-yoga-al'
import applovinActivityMaleTaiChiYogaAl from './areas/applovin/activity-male-tai-chi-yoga-al'
import applovinActivityMaleTaiChiWalkingAl from './areas/applovin/activity-male-tai-chi-walking-al'
import applovinMainAl from './areas/applovin/main-al'
import applovinFemaleAl from './areas/applovin/female-al'
import applovinMaleAl from './areas/applovin/male-al'
import applovinActivityFemaleTaiChiWalkingAl from './areas/applovin/activity-female-tai-chi-walking-al'
import applovinActivityFemaleTaiChiWalkingV2Al from './areas/applovin/activity-female-tai-chi-walking-v2-al'
import applovinFemaleWaterFastingAl from './areas/applovin/female-water-fasting-al'
import applovinActivityMaleChairWorkoutsAl from './areas/applovin/activity-male-chair-workouts-al'
import applovinActivityMaleChairTaiChiAl from './areas/applovin/activity-male-chair-tai-chi-al'

// other
import otherAssessment from './areas/other/assessment'
import otherTogether from './areas/other/together'
import otherWorkbooks from './areas/other/workbooks'

type FunnelGroup = {
	id: string
	name: string
	appAreas: AppAreaConfig[]
}

export const FUNNEL_GROUPS: FunnelGroup[] = [
	{
		id: 'fasting',
		name: 'Fasting',
		appAreas: [
			fastingFemale,
			fastingMale,
			fastingMain,
			fastingFemaleWaterBalance,
			fastingFemaleWaterFasting,
			fastingMaleWaterFasting,
			fastingFemaleAyurvedaFwf,
			fastingFemalePr,
			fastingMalePr,
			fastingMainPr,
		],
	},
	{
		id: 'yoga',
		name: 'Yoga',
		appAreas: [yogaActivityFemaleYoga, yogaActivityMaleChairWorkouts, yogaMainYoga],
	},
	{
		id: 'walking',
		name: 'Walking',
		appAreas: [
			walkingActivityFemaleWalking,
			walkingActivityFemaleNordicWalkingFwf,
			walkingActivityMaleWalking,
			walkingFemalePrintableWalking,
			walkingActivityFemaleWalkingJapanese,
			walkingActivityFemaleWalkingJapaneseV2,
			walkingMainWalking,
		],
	},
	{
		id: 'pilates',
		name: 'Pilates',
		appAreas: [
			pilatesActivityFemalePilates,
			pilatesActivityFemaleSeniorPilates,
			pilatesActivityFemaleBoudoirPilatesFwf,
			pilatesActivityFemaleAsianPilates,
		],
	},
	{
		id: 'activity',
		name: 'Activity',
		appAreas: [activityActivityFemaleV2, activityActivityMale, activityMainActivity],
	},
	{
		id: 'tai-chi',
		name: 'Tai Chi',
		appAreas: [
			taiChiActivityFemaleTaiChi,
			taiChiActivityFemaleTaiChiWalking,
			taiChiActivityFemaleTaiChiWalkingV2,
			taiChiActivityFemaleTaiChiWalkingPr,
			taiChiActivityFemaleChairTaiChiFwf,
			taiChiActivityMaleTaiChiWalking,
			taiChiActivityMaleTaiChiYoga,
			taiChiActivityMaleTaiChiYogaPr,
			taiChiMainTaiChi,
			taiChiMainTaiChiPr,
			taiChiMainTaiChiWalking,
			taiChiMainTaiChiWalkingPr,
			taiChiActivityMaleChairTaiChi,
			taiChiMaleGolfersFwf,
			taiChiMainChairTaiChiPr,
		],
	},
	{
		id: 'glp',
		name: 'GLP',
		appAreas: [glpFemaleGlp],
	},
	{
		id: 'calisthenics',
		name: 'Calisthenics',
		appAreas: [
			calisthenicsActivityFemaleCalisthenics,
			calisthenicsActivityMaleCalisthenics,
			calisthenicsMainCalisthenics,
			calisthenicsMilitaryMale,
		],
	},
	{
		id: 'diets',
		name: 'Diets',
		appAreas: [
			dietsFemaleCortisolDiet,
			dietsFemaleMenopauseDiet,
			dietsFemaleMediterraneanDiet,
			dietsFemaleAntiInflammatoryDiet,
			dietsFemaleHashimotoDiet,
			dietsFemaleHighProtein,
			dietsFemaleRamadanFwf,
			dietsCarnivoreDietGs,
			dietsCarnivoreDietGsMale,
			dietsCarnivoreDietGsFemale,
			dietsJapaneseDiet,
			dietsJapaneseDietMale,
			dietsJapaneseDietFemale,
			dietsFemaleKoreanGlowDiet,
		],
	},
	{
		id: 'applovin',
		name: 'AppLovin',
		appAreas: [
			applovinMainTaiChiWalkingAl,
			applovinActivityFemalePilatesAl,
			applovinActivityFemaleWalkingAl,
			applovinActivityFemaleYogaAl,
			applovinActivityMaleTaiChiYogaAl,
			applovinActivityMaleTaiChiWalkingAl,
			applovinMainAl,
			applovinFemaleAl,
			applovinMaleAl,
			applovinActivityFemaleTaiChiWalkingAl,
			applovinActivityFemaleTaiChiWalkingV2Al,
			applovinFemaleWaterFastingAl,
			applovinActivityMaleChairWorkoutsAl,
			applovinActivityMaleChairTaiChiAl,
		],
	},
	{
		id: 'other',
		name: 'Other',
		appAreas: [otherAssessment, otherTogether, otherWorkbooks],
	},
]

export const APP_AREAS: AppAreaConfig[] = FUNNEL_GROUPS.flatMap((group) => group.appAreas)

type DomainExclusiveGroup = {
	domain: string
	appAreas: AppAreaConfig[]
}

export const DOMAIN_EXCLUSIVE_GROUPS: DomainExclusiveGroup[] = [
	{
		domain: 'med.simple.life',
		appAreas: [medGlp1],
	},
]
